import LoadingButton from '@mui/lab/LoadingButton';
import { Stack } from '@mui/material';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import ExcelLogo from 'src/assets/svgComponents/ExcelLogo';
import ToolbarAni from './ToolbarAni.js';

function TableToolbar(props) {
  const { tableActions = {}, customTableActions = [] } = props;

  const {
    showDownloadCurrentPageAsExcelDocumentButton,
    downloadCurrentPageAsExcelDocumentButtonText,
    downloadCurrentPageAsExcelDocumentButtonHandler,
    showDownloadAllPagesAsExcelDocumentButton,
    downloadAllPagesAsExcelDocumentButtonText,
    downloadAllPagesAsExcelDocumentButtonHandler,
    loadingDownloadAllPagesAsExcelDocumentButton,
  } = tableActions;

  if (
    !showDownloadCurrentPageAsExcelDocumentButton &&
    !showDownloadAllPagesAsExcelDocumentButton &&
    customTableActions.length === 0
  ) {
    return null;
  }

  return (
    <Toolbar sx={{ pl: { sm: 0, md: 0 }, pr: { xs: 1, sm: 1 } }}>
      <Stack sx={{ width: "100%", padding: "0.5rem" }}><Stack direction="row" alignItems="center" spacing={2}>
        {showDownloadCurrentPageAsExcelDocumentButton && (
          <Button
            variant="contained"
            endIcon={<ExcelLogo />}
            color="success"
            sx={{
              backgroundColor: 'green',
              color: 'white',
              boxShadow: '0px 0px 0px 0px',
            }}
            size="small"
            onClick={downloadCurrentPageAsExcelDocumentButtonHandler}
          >
            {downloadCurrentPageAsExcelDocumentButtonText}
          </Button>
        )}
        {showDownloadAllPagesAsExcelDocumentButton && (
          <LoadingButton
            color="success"
            sx={{
              backgroundColor: 'green',
              color: 'white',
              boxShadow: '0px 0px 0px 0px',
            }}
            onClick={downloadAllPagesAsExcelDocumentButtonHandler}
            loading={loadingDownloadAllPagesAsExcelDocumentButton}
            size="small"
            /*  sx={{ width: '1rem' }} */
            variant="contained"
            endIcon={<ExcelLogo />}
          >
            {downloadAllPagesAsExcelDocumentButtonText}
          </LoadingButton>
        )}
        {Array.isArray(customTableActions) &&
          customTableActions.map((action, index) => (
            <Button
              variant="contained"
              color="success"
              endIcon={<ExcelLogo />}
              sx={{
                backgroundColor: 'green',
                color: 'white',
                boxShadow: '0px 0px 0px 0px',
              }}
              onClick={action.handler}
              key={`custom-table-action-${index}`}
            >
              {action.text}
            </Button>
          ))}
      </Stack>
        {
          props?.selectedRows && props?.selectedRows.length > 0 ? <ToolbarAni fetching={props.fetching} selectedRows={props.selectedRows} /> : null
        }
      </Stack>

    </Toolbar>
  );
}

export default TableToolbar;
